"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _createSvgIcon = _interopRequireDefault(require("./utils/createSvgIcon"));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("path", {
  d: "M6.5 11a6.5 6.5 0 1 0 6.5 6.5A6.51 6.51 0 0 0 6.5 11ZM9 17.22a.5.5 0 0 1-.45.28h-.93a.12.12 0 0 0-.12.12v2.88a1 1 0 0 1-2 0v-2.88a.13.13 0 0 0-.12-.12H4.5a.5.5 0 0 1-.45-.28.51.51 0 0 1 .06-.53l2-2.5a.51.51 0 0 1 .78 0l2 2.5a.51.51 0 0 1 .11.53Z"
}), /*#__PURE__*/_react.default.createElement("path", {
  d: "M23.41 3 21 .59A2 2 0 0 0 19.59 0H8a2 2 0 0 0-2 2v7.28a.26.26 0 0 0 .24.25c.37 0 1 0 1.49.08A.25.25 0 0 0 8 9.36V2.5a.5.5 0 0 1 .5-.5h10.88a.47.47 0 0 1 .35.15l2.12 2.12a.47.47 0 0 1 .15.35V18a.5.5 0 0 1-.5.5h-6.86a.25.25 0 0 0-.24.21 8.9 8.9 0 0 1-.4 1.46.24.24 0 0 0 .23.33H22a2 2 0 0 0 2-2V4.41A2 2 0 0 0 23.41 3Z"
}), /*#__PURE__*/_react.default.createElement("path", {
  d: "M19.5 10a.76.76 0 0 0-.4-.66l-5.85-3.23a.87.87 0 0 0-.83 0 .75.75 0 0 0-.42.66v4.83a.29.29 0 0 0 .07.18 7.87 7.87 0 0 1 1.36 1.73.25.25 0 0 0 .33.1l5.34-2.95a.76.76 0 0 0 .4-.66Z"
})), 'VideoFileUpload');

exports.default = _default;